import { fetchUtils, HttpError } from 'react-admin';
import { replaceQueryParams } from 'shared/utils/replace-query-params';

export const httpClient = (url: string, options: fetchUtils.Options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  const neededUrl = new URL(url);
  const replacedQueryParams = replaceQueryParams(neededUrl.search);
  neededUrl.search = replacedQueryParams;

  const token = localStorage.getItem('token');
  //@ts-ignore
  options.headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(neededUrl, options);
};

export function getErrors(httpError: HttpError): [string, string[]] {
  const { message, data } = httpError.body;

  const error = message || 'Ошибка';

  const errors: string[] = [];
  if (data.errors) {
    data.errors.forEach(({ constraints, children }: {constraints: Map<string, string>, children: any[]}) => {
      if (constraints) {
        for (let [key, value] of Object.entries(constraints)) {
          errors.push(value);
        }
      }

      children.map(({constraints, children }: {constraints: Map<string, string>, children: any[]}) => {
        if (constraints) {
          for (let [key, value] of Object.entries(constraints)) {
            errors.push(value);
          }
        }

        children.map(({constraints, children }: {constraints: Map<string, string>, children: any[]}) => {
          if (constraints) {
            for (let [key, value] of Object.entries(constraints)) {
              errors.push(value);
            }
          }
        });
      });
    });
  }

  return [error, errors];
}